var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[_c('help-content',{attrs:{"title":'計測データに関してご質問がある場合'}},[_c('template',{slot:"content"},[_c('div',{staticClass:"text"},[_vm._v("\n          ヘルプデスク("),_c('a',{attrs:{"href":"mailto:help@werunclub.net"}},[_vm._v("help@werunclub.net")]),_vm._v(")までご連絡ください。\n        ")])])],2)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c408811","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Help11.vue
// module id = PN8G
// module chunks = 0